import Spacer from './Spacer';
export * from './Spacer';
export default Spacer;
